export const userConstants = {
    AJAX_CALL_REQUEST: '[User] Ajax call user request',
    AJAX_CALL_SUCCESS: '[User] Ajax call user success',
    AJAX_CALL_FAILURE: '[User] Ajax call user failed',
    CHECK_USER_AUTH_DONE: '[User] Check user authentication done',
    UPDATE_USER: '[User] Document updated',
    LOGOUT_SUCCESS: '[User] Logout success',
    LOGOUT_REQUEST: '[User] Logout request',
    VERIFY_EMAIL_SUCCESS: '[User] Verify email success',
}
